import { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Form } from 'redux-form';

import {
  convertDateStringToISODate,
  dateFormatNoTimeZone
} from 'common/helpers/dateHelper';
import { convertStringToInteger } from 'common/helpers/numberHelper';
import { getReservationTypeBySlug } from 'redux/reservationTypes/reducers';
// eslint-disable-next-line import/no-cycle
import LoginToPurchase from 'reservations/availability/LoginToPurchase';

import GuestCount from './components/GuestCount';
import ReservationDate from './components/ReservationDate';
import ReservationTime from './components/ReservationTime';
import { validateSearchWidget } from './validators';

class SearchFormWidget extends Component {
  componentDidMount() {}

  componentDidUpdate(prevProps) {
    const { props } = this;
    const prevDate = prevProps.reservationDate;
    const currentDate = props.reservationDate;
    if (currentDate && currentDate !== prevDate) {
      props.change('reservationDate', dateFormatNoTimeZone(currentDate));
    }
  }

  handleSubmit = (form) => {
    const { props } = this;
    const data = transformData(form);
    props.onSearch(data);
  };

  render() {
    const { props } = this;
    const { settings, handleSubmit } = this.props;
    if (!settings.data) {
      return null;
    }
    const reservationType = getReservationTypeBySlug(
      props.reservationType,
      props.reservationTypeSlug
    );
    if (!reservationType) {
      return null;
    }
    if (
      reservationType.security &&
      reservationType.security.availableTo !== 'Public' &&
      !reservationType.security.isValidUser
    ) {
      return <LoginToPurchase reservationType={reservationType} />;
    }
    return (
      <div className="c7-reservation-widget c7-reservation-widget--search">
        <Form
          onSubmit={handleSubmit(this.handleSubmit)}
          className="c7-form c7-reservation-widget"
        >
          <div>
            <div className="c7-form__group">
              <ReservationDate settings={settings} />
              <GuestCount
                settings={settings}
                reservationType={reservationType}
              />
              <ReservationTime settings={settings} />
            </div>
          </div>
          <button className="c7-button" type="submit">
            Check Availability
          </button>
        </Form>
      </div>
    );
  }
}

const transformData = (values) => {
  const data = {
    guestCount: values.guestCount && convertStringToInteger(values.guestCount),
    reservationTime: values.reservationTime
  };
  try {
    data.reservationDate = convertDateStringToISODate(values.reservationDate);
  } catch {
    data.reservationDate = values.reservationDate;
  }
  return data;
};

const validate = (values) => {
  const data = transformData(values);
  const errors = validateSearchWidget(data);
  return errors;
};

const mapStateToProps = (state, ownProps) => {
  const reservationType = getReservationTypeBySlug(
    state.reservationType,
    ownProps.reservationTypeSlug
  );
  let guestCount = 2;
  if (reservationType && reservationType.maxGuestCount === 1) {
    guestCount = 1;
  }
  if (reservationType && reservationType.minGuestCount > 2) {
    guestCount = reservationType.minGuestCount;
  }

  return {
    initialValues: {
      guestCount
    },
    settings: state.setting,
    reservationType: state.reservationType
  };
};

SearchFormWidget = reduxForm({
  // form: props.reservationTypeSlug,
  // form name comes from props
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(SearchFormWidget);

export default connect(mapStateToProps)(SearchFormWidget);
